<template>
  <upper></upper>
  <el-row>
    <el-col :md="4" :sm="aside_sm" :xs="aside_xs">
      <div class="aside">
        <el-collapse v-model="activeNames" @change="getDirectory">
          <el-collapse-item name="1">
            <template #title>
              <span>&nbsp;&nbsp;</span>
              <el-icon size="18" @click="refresh.stop"><Refresh /></el-icon>
              <span>&nbsp;&nbsp;</span>
              <el-icon size="16"><Folder></Folder></el-icon>
              <span>&nbsp;Slide Library</span>
            </template>
            <el-tree
                v-show="tree"
                lazy
                :empty-text="($t('setting.null'))"
                style="max-width: 600px"
                :highlight-current="true"
                :props="defaultProps"
                :load="loadNode"
                @node-click="handleNodeClick"
                :render-content="renderContent"
            ></el-tree>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="aside_mobile">
        <div class="folder_icon" @click="expand">
          <el-popover
              v-model:visible="visible"
              trigger="manual"
              placement="bottom"
              :width="120"
              content="点击可选择目录"
          >
            <template #reference>
              <el-icon color="#FFF" size="28"><Folder /></el-icon>
            </template>
          </el-popover>
        </div>
        <el-drawer
            ref="drawerRef"
            v-model="dialog"
            title=""
            :before-close="handleClose"
            direction="ltr"
            size="55%"
            custom-class="demo-drawer"
        >
          <div class="demo-drawer__content">
            <el-collapse v-model="activeNames" @change="getDirectory">
              <el-collapse-item title="directory" name="1">
                <template #title>
                  <span>&nbsp;&nbsp;</span>
                  <el-icon size="18" @click="refresh"><Refresh /></el-icon>
                  <span>&nbsp;&nbsp;</span>
                  <el-icon size="16"><Folder></Folder></el-icon>
                  <span>&nbsp;Slide Library</span>
                </template>
                <el-tree
                    v-if="tree"
                    lazy
                    :empty-text="($t('setting.null'))"
                    style="max-width: 600px"
                    :highlight-current="true"
                    :props="defaultProps"
                    :load="loadNode"
                    @node-click="handleNodeClick"
                    :render-content="renderContent"
                ></el-tree>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-drawer>
      </div>
    </el-col>
    <el-col :md="20" :sm="body_sm" :xs="body_xs">
      <div class="popover" v-show="popover_visible">
        <p @click="login_out"><el-icon style="padding-left: 10px;padding-right: 4px;"><SwitchButton /></el-icon>退出登录</p>
      </div>
      <div class="body">
        <div class="export-toolbar">
          <el-button
              type="primary"
              :loading="exporting"
              :disabled="slideData.length === 0"
              @click="exportSlides"
          >
            <el-icon><Download /></el-icon>
            <span>{{ $t('body.export_all') }}</span>
          </el-button>
        </div>
        <div class="item" v-for="(item,index) in slideData" :key="index">
          <div class="slide" @click="browse(item)">
<!--            <el-image class="label" :src="'/slide/Image/Label?path=' + encryptECB(item.fullName)" @error="handleError">
              <template #error>
                <div class="custom-error-content">
                  <el-icon color="#606266"><PictureFilled /></el-icon>
                </div>
              </template>
            </el-image>-->
            <el-image class="preview" :src="'/slide/Image/Preview?path=' + encryptECB(item.fullName)">
              <template #error>
                <div class="custom-error-content">
                  <el-icon color="#606266"><PictureFilled /></el-icon><p class="error-text">{{ $t('body.error') }}</p>
                </div>
              </template>
            </el-image>
          </div>
          <p><el-icon><Tickets /></el-icon><span class="slide_info">&nbsp;{{item.name}}</span></p>
          <p><el-icon><Timer /></el-icon><span class="slide_info">&nbsp;{{item.creationTime}}</span></p>
          <p @click="share(item)"><span class="slide_share"><el-icon><Share /></el-icon>&nbsp;{{ $t('body.share_click') }}</span></p>
        </div>
      </div>
    </el-col>
    <categoryManage></categoryManage>
    <share></share>
    <setting></setting>
  </el-row>
</template>

<script>
import upper from '../components/Header.vue'
import categoryManage from "@/components/dialogue/category manage.vue";
import share from "@/components/dialogue/share.vue";
import setting from "@/components/dialogue/setting.vue";
import { ElIcon } from 'element-plus';
import folder from '@/assets/img/dir.png'
import {encryptECB} from "@/aes/aes";
export default {
  data () {
    return {
      activeNames: ['1'],
      visible: true,
      isMobile: null,
      dialog: false,
      aside_sm: 2,
      body_sm: 22,
      aside_xs: 3,
      body_xs: 21,
      symbol: '',
      tree: true,
      label_show: true,
      treeData: [],
      path: 'E:\\',
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'isFile'
      },
      slideData: [],
      popover_visible: false,
      timer: '',
      exporting: false,
    }
  },
  components: {
    upper,
    categoryManage,
    share,
    setting,
    ElIcon,
  },
  computed: {
  },
  methods: {
    encryptECB,
    refresh () {
      if (this.symbol != 0) {
        this.updateFiles()
      }
    },
    popover_show () {
      this.popover_visible = !this.popover_visible
    },
    login_out() {
      this.axios.post('/api/auth/logout').then(res => {
        this.$router.push('/')
      })
    },
    expand() {
      this.dialog = true
      this.aside_open = true
      /*this.aside_sm = 8
      this.body_sm = 16
      this.aside_xs = 12
      this.body_xs = 12*/
    },
    checkWindowSize() {
      this.visible = window.innerWidth <= 992
    },
    fold() {
      this.aside_open = false
      this.aside_sm = 3
      this.body_sm = 21
    },
    getDirectory(e) {
      this.activeNames.value = e;
      this.symbol = e.length
      if (e.length != 0) {
        this.updateFiles()
        /*this.axios.get('/service/getFilePath?path=E:\\slides\\qptiff&type=1').then(res => {
          let data = JSON.parse(res.data)
          this.slideData = data.children
        })*/
        let p = this.$route.params.folderName;
        if (!p) {
          p = 'slides';
        }
        this.axios.get('/service/getFilePath?path=E:\\' + p + '\\qptiff' + '&type=1').then(res => {
          let data = JSON.parse(res.data)
          this.slideData = data.children
        })
      }
    },
    loadNode (node, resolve) {
      let p = this.$route.params.folderName;
      if (!p) {
        p = 'slides';
      }
      if (node.level === 0) {
        this.axios.get('/service/getFilePath?path=' + this.path + p + '&type=0').then(res => {
          this.treeData = JSON.parse(res.data)
          return resolve(this.treeData.children)
        })
      } else {
        this.axios.get('/service/getFilePath?path=' + node.data.fullName + '&type=0').then(res => {
          if (res.data.length === 0) {
            return resolve([])
          } else {
            let d = JSON.parse(res.data)
            let data = d.children
            return resolve(data)
          }
        })
      }
    },
    handleNodeClick (e) {
      this.axios.get('/service/getFilePath?path=' + e.fullName + '&type=1').then(res => {
        let data =  JSON.parse(res.data)
        this.slideData = data.children
      })
    },
    renderContent(h,{ node, data }) {
      return h('span', [
        h('img', {
          src: folder, // 使用本地图标资源
          style: { width: '20px', height: '20px', marginRight: '5px' },
        }),
        h('span', { style: { marginLeft: '5px' } }, data.name), // 标签内容
      ]);
    },
    browse (item) {
      window.open(`/slideViewer/#/viewer?url=` + encryptECB(item.fullName))
    },
    getShareLink (item) {
      return window.location.origin + '/slideViewer/#/viewer?url=' + encryptECB(item.fullName)
    },
    share (item) {
      this.eventBus.emit('share', this.getShareLink(item))
    },
    async exportSlides () {
      if (this.slideData.length === 0 || this.exporting) {
        return
      }

      this.exporting = true
      try {
        const excelModule = await import(/* webpackChunkName: "exceljs" */ 'exceljs')
        const ExcelJS = excelModule.default || excelModule
        const workbook = new ExcelJS.Workbook()
        workbook.creator = 'Slide Library'
        workbook.created = new Date()

        const worksheet = workbook.addWorksheet(this.$t('body.export_sheet'), {
          views: [{ state: 'frozen', ySplit: 1 }]
        })
        worksheet.columns = [
          { header: this.$t('body.serial_no'), key: 'index', width: 10 },
          { header: this.$t('body.slide_name'), key: 'name', width: 30 },
          { header: this.$t('body.slide_link'), key: 'link', width: 90 }
        ]

        this.slideData.forEach((item, index) => {
          const shareLink = this.getShareLink(item)
          const row = worksheet.addRow({
            index: index + 1,
            name: item.name || '',
            link: {
              text: shareLink,
              hyperlink: shareLink,
              tooltip: item.name || shareLink
            }
          })
          row.height = 42
        })

        const header = worksheet.getRow(1)
        header.height = 28
        header.font = { name: 'Arial', size: 11, bold: true, color: { argb: 'FFFFFFFF' } }
        header.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF3EA7C5' } }
        header.alignment = { horizontal: 'center', vertical: 'middle' }

        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber > 1) {
            row.font = { ...row.font, name: 'Arial', size: 11 }
            row.alignment = { vertical: 'middle' }
            row.getCell('index').alignment = { horizontal: 'center', vertical: 'middle' }
            row.getCell('name').alignment = { horizontal: 'left', vertical: 'middle' }
            row.getCell('link').alignment = { horizontal: 'left', vertical: 'middle', wrapText: true }
            row.getCell('link').font = {
              name: 'Arial',
              size: 11,
              color: { argb: 'FF0563C1' },
              underline: true
            }
          }
          row.eachCell(cell => {
            cell.border = {
              bottom: { style: 'thin', color: { argb: 'FFD9E0E6' } }
            }
          })
        })
        worksheet.autoFilter = 'A1:C1'

        const buffer = await workbook.xlsx.writeBuffer()
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const downloadUrl = URL.createObjectURL(blob)
        const downloadLink = document.createElement('a')
        downloadLink.href = downloadUrl
        downloadLink.download = this.$t('body.export_filename')
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
        setTimeout(() => URL.revokeObjectURL(downloadUrl), 0)
        this.$message.success(this.$t('body.export_success'))
      } catch (error) {
        console.error('Failed to export slide links:', error)
        this.$message.error(this.$t('body.export_fail'))
      } finally {
        this.exporting = false
      }
    },
    updateFiles () {
      this.tree = false
      this.$nextTick(() => {
        this.tree = true
      })
    }
  },
  mounted() {
    /*this.axios.post('api/auth/category_list').then(res => {
      this.treeData = res.data.data
    })*/
    this.checkWindowSize()
    setTimeout(() => {
      this.visible = false
    }, 3000)
    this.getDirectory([1])
    this.eventBus.on('popover_show', this.popover_show)
    console.log('parameter:' + this.$route.params.folderName)
  }
}
</script>

<style>
.aside{
  width: 100%;
  height: 94vh;
  background-color: #2c3b41;
}
.aside .el-collapse-item__content{
  height: 776px;
  overflow: auto;
}
.aside_mobile{
  width: 100%;
  height: 94vh;
  background-color: #2c3b41;
}
.aside_mobile .el-collapse-item__content{
  height: 80vh;
  overflow: auto;
}
.aside_mobile .el-drawer__header{
  margin: 0;
  padding: 10px 10px 5px 0px;
}
.folder_icon{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
}
.folder_icon i{
  cursor: pointer;
}
.folder_icon:hover{
  background-color: rgba(255,255,255,0.2);
}
.body{
  background-color: #ecf0f5;
  width: 100%;
  height: 94vh;
  display: flex;
  padding: 20px 5px;
  align-content: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  box-sizing: border-box;
  overflow: auto;
}
.export-toolbar{
  flex: 0 0 100%;
  min-height: 32px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding: 0 15px 15px 20px;
  box-sizing: border-box;
}
.export-toolbar .el-button span{
  display: inline-flex;
  align-items: center;
}
.popover{
  position: absolute;

  width: 150px;
  height: 50px;
  background-color: white;
  color: black;
  right: 0;
  top: 0;
  cursor: pointer;
}
.popover:hover{
  background-color: rgba(0,0,0,0.1);
}
.item{
  width: 18%;
  min-width: 270px;
  height: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  margin: 0px 0px 20px 20px;
}
.item p{
  margin: 4px 2px;
}
.slide{
  height: 100px;
  width: 180px;
  margin-bottom: 2px;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 15px;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: inset 0 5px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3c8dbc;
  font-size: 1.5rem;
  text-align: center;
}
.slide .label{
  width: 75px;
  height: 75px;
}
.slide .preview{
  width: 150px;
  height: 75px;
}
.custom-error-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: #f2f2f2;
}

.error-text {
  margin-top: 10px;
  color: #666;
  font-size: 14px;
}
.slide_info{
  font-size: 14px;
}
.slide_share{
  font-size: 14px;
  color: #3c8dbc;
  cursor: pointer;
  text-decoration: underline;
}
</style>
